/**
 * Auth Page Component for Stenope Academy
 * 
 * Simple authentication page that shows the login form.
 */

import React from 'react';
import LoginForm from './LoginForm';

const AuthPage = () => {
    return <LoginForm />;
};

export default AuthPage;
